import { useEffect } from 'react'
import { Box, useMediaQuery } from '@mui/material'
import { FormProvider, useForm } from 'react-hook-form'

import { BaseModal2 } from '@components/modals/BaseModal2'
import { emotionTheme } from '@styles/theme'
import { FilesIcon } from '@assets/svgs/FilesIcon'
import { initialFormValues } from './form/initialFormValues'
import { Input } from '@components/shared/Input'
import { RowBox } from '@components/shared/RowBox'
import { setInitialValues } from './form/setInitialValues'
import { Title } from '@components/shared/Title'
import { useUsers } from '@pages/Users/context'

import type { UserDetailsModalFormProps } from './form/types'
import type { UserDetailsModalProps } from './types'

export const UserDetailsModal = ({ open, onClose, data, userData, ...rest }: UserDetailsModalProps) => {
  const isMobile = useMediaQuery(`(max-width: ${emotionTheme.screenSizes.laptop})`)

  const { clDetailsData, isClDetailsLoading, getClDetails } = useUsers()

  const methods = useForm<UserDetailsModalFormProps>({
    defaultValues: initialFormValues
  })

  const handleGetClDetails = () => {
    getClDetails({
      userCode: userData?.code!,
      profitCenterId: data?.code!
    })
  }

  useEffect(() => {
    if (!!data && !!userData && open) {
      handleGetClDetails()
      handleSetInitialValues()
    }
  }, [data, userData, open])

  const handleSetInitialValues = () => {
    methods.reset(setInitialValues(clDetailsData)!)
  }

  useEffect(() => {
    !!clDetailsData && handleSetInitialValues()
  }, [clDetailsData])

  return (
    <BaseModal2
      open={open}
      width={isMobile ? 'calc(100% - 20px)' : 870}
      heightContainer="auto"
      maxHeightContainer={isMobile ? 'calc(100% - 20px)' : '80%'}
      title={`Visualizar ${data?.code || ''}`}
      headerIcon={<FilesIcon />}
      onClose={onClose}
      loading={isClDetailsLoading}
      {...rest}
    >
      <Title label="Detalhes do Centro de Lucro" marginTop={0} />

      <FormProvider {...methods}>
        <RowBox columns={11}>
          <Input hasController={false} name="id" label="ID" value="1" isIcon={false} disabled />
          <Box sx={{ gridColumn: 'span 5' }}>
            <Input name="profitCenterCode" label="Centro de Lucro" disabled />
          </Box>
          <Box sx={{ gridColumn: 'span 5' }}>
            <Input name="businessUnit" label="BU" disabled />
          </Box>
        </RowBox>

        <RowBox columns={3} marginTop={24}>
          <Input name="segment" label="Segmento" disabled />
          <Input name="directorate" label="Diretoria" disabled />
          <Input name="profitCenter" label="Centro de Lucro" disabled />
        </RowBox>

        <RowBox columns={2} marginTop={24}>
          <Input name="profitCenterName" label="Nome do Centro de Lucro" disabled />
          <Input name="profitCenterType" label="Tipo de Centro de Lucro" disabled />
        </RowBox>

        <RowBox columns={11} marginTop={24}>
          <Box sx={{ gridColumn: 'span 2' }}>
            <Input name="cep" label="CEP" disabled />
          </Box>
          <Box sx={{ gridColumn: 'span 3' }}>
            <Input name="address" label="Endereço" disabled />
          </Box>

          <Input name="number" label="Número" disabled />

          <Box sx={{ gridColumn: 'span 3' }}>
            <Input name="neighborhood" label="Bairro" disabled />
          </Box>
          <Box sx={{ gridColumn: 'span 2' }}>
            <Input name="city" label="Cidade" disabled />
          </Box>
        </RowBox>

        <RowBox columns={11} marginTop={24}>
          <Input name="uf" label="UF" disabled />
          <Box sx={{ gridColumn: 'span 5' }}>
            <Input name="email" label="E-mail" disabled />
          </Box>
          <Box sx={{ gridColumn: 'span 5' }}>
            <Input name="regional" label="Regional" disabled />
          </Box>
        </RowBox>

        <RowBox columns={2} marginTop={24}>
          <Input name="managerAreaName" label="Nome do Gerente de Área" disabled />
          <Input name="managerAreaEmail" label="E-mail do Gerente de Área" disabled />
        </RowBox>
      </FormProvider>
    </BaseModal2>
  )
}
